import type { ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';

const SidebarSection = ({
  title,
  icon,
  badge,
  defaultOpen = true,
  children,
}: {
  title: string;
  icon: ReactNode;
  badge?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
}) => (
  <details open={defaultOpen} className="group/sidebar rounded-xl border border-gray-200 bg-white">
    <summary className="flex cursor-pointer select-none list-none items-center justify-between gap-2 px-3 py-2.5">
      <span className="flex items-center gap-2 text-sm font-semibold text-gray-700">
        {icon}
        {title}
      </span>
      <span className="flex items-center gap-2">
        {badge}
        <ChevronDown className="w-4 h-4 text-gray-400 transition-transform group-open/sidebar:rotate-180" />
      </span>
    </summary>
    <div className="border-t border-gray-100 px-3 py-3 space-y-2">{children}</div>
  </details>
);

export default SidebarSection;
